import { userService } from '_services'
import { log } from '_services'
import { store } from '_helpers'
import { userActions } from '_actions';



export async function handleRequest(uri, requestOptions = {}, withAuth = false, jsonResponse = true) {
    if (withAuth) {
        let jwtToken = localStorage.getItem('pterotoken');
        const companyId = sessionStorage.getItem('companyId');
        if(companyId !== null 
            && 
            companyId !== undefined
            && localStorage.getItem(`pterotoken_${companyId}`) !== null
        )
        {
                jwtToken= localStorage.getItem(`pterotoken_${companyId}`);
        }
        
        requestOptions.headers = { ...requestOptions.headers, 'Authorization': 'Bearer ' + jwtToken, "X-Version": process.env.REACT_APP_VERSION }

    }

    return await fetch(uri, requestOptions)
        .then(response => handleResponse(response, uri, requestOptions, withAuth, jsonResponse));
}

let refreshPromise;

async function handleResponse(response, uri, requestOptions, withAuth, jsonResponse) {

    const contentType = response.headers.get('X-Refresh-Needed');

    if (contentType && contentType === "true") {
        //store.dispatch(dashboardActions.loadTodaysScheduleQuiet());
        store.dispatch(userActions.forceRefresh(true));
    }


    if (!response.ok) {
        if (response.status === 401) {
            if (!refreshPromise) {
                const companyId = sessionStorage.getItem('companyId');
                if(companyId !== null && companyId !== undefined && localStorage.getItem(`pterotoken_${companyId}`) !== null)
                {
                    refreshPromise = refresh(localStorage.getItem(`pterotoken_${companyId}`), localStorage.getItem(`pterorefreshtoken_${companyId}`)).then(success => {
                        refreshPromise = null;
                        return success;
                });
                }
                else{
                    refreshPromise = refresh(localStorage.getItem('pterotoken'), localStorage.getItem('pterorefreshtoken')).then(success => {
                        refreshPromise = null;
                        return success;
                    });  
                }
            }


            return refreshPromise.then(success => {
                if (success) {
                    return handleRequest(uri, requestOptions, withAuth, jsonResponse); //repeat the original request        
                } else {
                    userService.logout();
                    window.location.reload(true);
                }

            })
        } else {
            return Promise.reject(
                'Error attempting to call Web API: '
                + uri + ' '
                + response.status + ' '
                + response.statusText + ' '
                + await response.text()
            );
        }
    }

    var data;
    if (jsonResponse && response.ok) {
        var respText = await response.text();
        data = JSON.parse(respText);
    } else {
        data = response;
    }
    return data;
}

async function refresh(jwtToken, refreshToken) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ token: jwtToken, refreshToken })
    };

    var refreshResponse = await fetch(process.env.REACT_APP_API_URI + '/users/refresh', requestOptions)
        .catch((error) => { log.info("refresh fetch caught error" + error.message); return Promise.reject(error.message); });

    if (!refreshResponse.ok) {
        return false;
    }
    var jsonRefreshResponse = await refreshResponse.json(); //read the json with the new tokens
    

    localStorage.setItem('pterotoken', jsonRefreshResponse.token);
    localStorage.setItem('pterorefreshtoken', jsonRefreshResponse.refreshToken);
    const companyId = sessionStorage.getItem('companyId');
    if(companyId !== null && companyId !== undefined && localStorage.getItem(`pterotoken_${companyId}`) !== null)
    {
        localStorage.setItem(`pterotoken_${companyId}`, jsonRefreshResponse.token);
        localStorage.setItem(`pterorefreshtoken_${companyId}`, jsonRefreshResponse.refreshToken);
    }
    
    return true;
}

